import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CrearDeudaRequest } from 'src/app/core/dtos/crearDeudaRequest';
import { DeudaResponse } from 'src/app/core/dtos/deudaResponse';
import { ActualizarPreciosRequest } from 'src/app/core/dtos/actualizarPreciosRequest';
import { environment } from 'src/environments/environment.development';


@Injectable({
  providedIn: 'root'
})
export class DeudaService {

  
  private apiUrl = `${environment.apiUrl}/Deudas/`;

  constructor(private http: HttpClient) {}

  
  obtenerDeudaPorCliente(usuarioId:number,clienteId: number): Observable<DeudaResponse[]> {
    return this.http.get<DeudaResponse[]>(`${this.apiUrl}getByClienteId?clienteId=${clienteId}&usuarioId=${usuarioId}`);
  }

  crearDeuda(usuarioId: number,request:CrearDeudaRequest): Observable<any> {
    return this.http.post(`${this.apiUrl}create?usuarioId=${usuarioId}`, request);
  }
  
  actualizarPrecios(clienteId: number, detalles: ActualizarPreciosRequest) {
  return this.http.put(`${this.apiUrl}${clienteId}/actualizar-precios`, detalles);
}

}